import React, { ReactElement } from "react";
import { useStyles } from "./Header.styles";
import { Box, useMediaQuery, useTheme } from "@mui/material";

// import  logo from "assets/logo.svg"

interface HeaderProps {
    flex?: boolean;
}

const Header = ({ flex }: HeaderProps): ReactElement => {
    const styles = useStyles();
    const theme = useTheme();
    const mdUp = useMediaQuery(theme.breakpoints.up("md"));

    return (
        <Box sx={{ flexGrow: flex ? 1 : 0, maxHeight: flex ? "100%" : "20Vh" }} className={mdUp ? styles.headerMd : styles.header}>
            <svg
                className={mdUp ? styles.logoMd : styles.logo}
                x="0px"
                y="0px"
                viewBox="0 0 1334.26 425.2"
                enableBackground="new 0 0 1334.26 425.2"
            >
                <path
                    fill="#F24F00"
                    d="M354.33,159.88h35.4c29.07,0,54.53,16.72,54.53,52.72c0,35.85-25.46,52.72-54.53,52.72h-35.4V159.88z
     M387.47,245.74c17.32,0,33.89-8.28,33.89-33.14c0-24.85-16.57-33.29-33.89-33.29h-10.54v66.43H387.47z"
                />
                <rect x="459.18" y="159.88" fill="#F24F00" width="22.75" height="105.44" />
                <path
                    fill="#F24F00"
                    d="M495.33,229.47h21.69c0.9,10.69,7.98,17.47,19.13,17.47c10.09,0,16.87-4.22,16.87-12.2
    c0-20.64-54.68-4.82-54.68-46.24c0-17.47,15.06-29.83,36.45-29.83c22.75,0,38.11,13.11,38.71,33.14h-21.54
    c-0.75-8.28-7.08-13.71-17.17-13.71c-8.89,0-14.46,4.22-14.46,10.39c0,21.99,55.43,4.22,55.43,45.94
    c0,19.73-15.97,32.08-39.62,32.08C512.2,266.53,496.23,251.92,495.33,229.47"
                />
                <polygon
                    fill="#F24F00"
                    points="609.36,179.31 578.18,179.31 578.18,159.88 663.14,159.88 663.14,179.31 631.96,179.31
    631.96,265.32 609.36,265.32 "
                />
                <path
                    fill="#F24F00"
                    d="M671.73,159.88h44.44c22.59,0,35.7,13.86,35.7,33.14c0,10.7-5.12,17.77-13.41,22.14
    c6.93,4.52,11.15,11.9,12.05,21.09l2.86,29.07h-22.6l-2.86-26.06c-0.75-7.23-5.88-12.2-12.95-12.2h-20.49v38.26h-22.75V159.88z
     M714.96,207.63c10.39,0,14.91-6.93,14.91-14.61c0-7.53-4.52-14.31-14.91-14.31h-20.49v28.92H714.96z"
                />
                <rect x="771.6" y="159.88" fill="#F24F00" width="22.75" height="105.44" />
                <path
                    fill="#F24F00"
                    d="M813.93,159.88h41.88c19.13,0,33.44,9.49,33.44,27.11c0,9.94-6.18,17.47-12.35,20.79
    c9.64,3.77,17.77,12.2,17.77,26.06c0,20.03-15.36,31.48-37.66,31.48h-43.08V159.88z M854.15,200.1c9.64,0,14.16-4.07,14.16-11.15
    c0-7.08-4.52-11.15-14.61-11.15h-17.47v22.29H854.15z M855.05,245.74c12.5,0,18.08-4.52,18.08-13.1c0-8.59-5.57-13.41-18.08-13.41
    h-18.83v26.51H855.05z"
                />
                <path
                    fill="#F24F00"
                    d="M907.18,226.46v-66.58h21.24v66.58c0,13.86,8.59,20.34,20.79,20.34c12.2,0,20.94-6.48,20.94-20.34v-66.58
    h21.09v66.58c0,26.66-17.02,40.07-42.03,40.07C924.35,266.53,907.18,253.12,907.18,226.46"
                />
                <path
                    fill="#F24F00"
                    d="M1004.04,212.6c0-35.55,24.71-53.93,52.87-53.93c26.51,0,45.94,15.06,48.81,37.81h-23.65
    c-1.51-11-11.9-18.38-25.16-18.38c-17.02,0-30.13,11.9-30.13,34.5c0,22.6,13.11,34.35,30.13,34.35c13.56,0,23.95-7.38,25.76-18.23
    h22.59c-1.96,22.6-21.39,37.81-48.35,37.81C1028.29,266.53,1004.04,248.15,1004.04,212.6"
                />
                <polygon
                    fill="#F24F00"
                    points="1119.13,159.88 1190.83,159.88 1190.83,179.31 1141.72,179.31 1141.72,201.6 1180.89,201.6
    1180.89,221.19 1141.72,221.19 1141.72,245.74 1192.49,245.74 1192.49,265.32 1119.13,265.32 "
                />
                <rect y="70.87" fill="#63666A" width="283.46" height="283.46" />
                <rect x="124.16" y="195.02" fill="#FFFFFF" width="104.03" height="35.15" />
                <polygon
                    fill="#FFFFFF"
                    points="53.86,124.72 53.86,300.47 229.61,300.47 229.61,265.32 89.01,265.32 89.01,159.87 229.61,159.87
    229.61,124.72 "
                />
            </svg>
        </Box>
    );
};
export default Header;
